// extracted by mini-css-extract-plugin
export var brand = "_ac-9";
export var compact = "_ac-6";
export var extraSmall = "_ac-7";
export var icon = "_ac-0";
export var large = "_ac-4";
export var light = "_ac-1";
export var medium = "_ac-5";
export var outline = "_ac-b";
export var primaryDark = "_ac-a";
export var primaryLight = "_ac-8";
export var primaryModern = "_ac-c";
export var success = "_ac-2";
export var successSolid = "_ac-3";